import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import conditionsData from '../../conditiondata.json';
import conditionsData from '../../conditions.json'

const ConditionsGrid = ({ query = '' }) => {
  const navigate = useNavigate();
// console.log(conditionsData.conditions,"this is")
  const filtered = conditionsData.conditions?.conditions.filter(c =>
    c.name.toLowerCase().includes(query.toLowerCase()) ||
    c.description.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <section
      id="conditions"
     
      // style={{ backgroundColor: '#F4F6FA' }}

      className="w-full py-0.5 px-4 sm:px-6"
    >
      <div className="max-w-5xl mx-auto">
        {filtered.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
            {filtered.map(condition => (
              <div
                key={condition.id}
                className="bg-white ava-card-mukta ava-radius-md p-4 cursor-pointer transition-all duration-200 flex flex-col gap-2"
                // onMouseEnter={e => {
                //   e.currentTarget.style.borderColor = 'var(--primary-color)';
                //   e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
                // }}
                // onMouseLeave={e => {
                //   e.currentTarget.style.borderColor = '#f3f4f6';
                //   e.currentTarget.style.boxShadow = 'none';
                // }}
                onClick={() => navigate(`/conditions/${condition.slug}`)}
              >
                {/* Icon */}
                <div
                  className="w-16 h-16 ava-card-bg rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ 
                    // backgroundColor: '#EAF1FF',
                     color: 'var(--primary-color)' }}
                  // dangerouslySetInnerHTML={{ __html: condition.icon }}

                >
                  <img src={condition.icon} alt={condition.name} />
                </div>

                {/* Name */}
                <p className="ava-text-subheading">
                  {condition.name}
                </p>

                {/* Description */}
                <p className="ava-text-body primary-text flex-1">
                  {condition.description}
                </p>

                {/* Arrow button — right aligned */}
                <div className="flex justify-end ">
                  <div
                    className="w-10 h-10 ava-card-bg rounded-full flex items-center justify-center border transition-colors duration-200"
                    style={{
                      borderColor: 'var(--primary-color)',
                      // backgroundColor: '#EAF1FF',
                       color: 'var(--primary-color)'
                    }}
                  >
                    <svg
                      width="15"
                      height="15"
                      fill="none"
                      stroke='var(--primary-color)'
                      strokeWidth="2.5"
                      viewBox="0 0 24 24"
                    >
                      <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 text-gray-400 text-sm">
            No conditions found. Try different keywords.
          </div>
        )}
      </div>
    </section>
  );
};

export default ConditionsGrid;